import {
  GET_STAFF_REPORTS,
  PREGENERATE_STAFF_REPORT,
  GET_STAFF_CACHE_STATUS,
  INVALIDATE_STAFF_CACHE,
  GET_STAFF_ACCESS_LOGS,
  UPDATE_STAFF_REPORT_PAGE_NUMBER,
} from 'constants/actions';

const initialState = {
  reports: [],
  pageNumber: 1,
  queryParams: '',
  cache_status: null,
  pregen_result: null,
  access_logs: null,
  pending: false,
  last_success: null,
  last_error: null,
};

export default function staffReports(state = initialState, action = {}) {
  switch (action.type) {
    case GET_STAFF_REPORTS:
      return { ...state, reports: action.payload, pending: false };

    case "STAFF_REPORTS_PENDING":
      return { ...state, pending: true, last_error: null, last_success: null };

    case PREGENERATE_STAFF_REPORT: {
      const created = action.payload;
      let nextReports = state.reports;
      // normalized shape: { reports: [...], total: n }
      if (state.reports && state.reports.reports && Array.isArray(state.reports.reports)) {
        const prev = state.reports.reports || [];
        const total = typeof state.reports.total === 'number' ? state.reports.total + 1 : undefined;
        nextReports = { ...state.reports, reports: [created, ...prev], ...(total !== undefined ? { total } : {}) };
      } else if (Array.isArray(state.reports)) {
        nextReports = [created, ...state.reports];
      } else {
        nextReports = Array.isArray(created) ? created : (created ? [created] : []);
      }

      return { ...state, pregen_result: action.payload, reports: nextReports, pending: false };
    }

    case "STAFF_REPORTS_OPERATION_SUCCESS":
      return { ...state, pending: false, last_success: action.payload };

    case "STAFF_REPORTS_OPERATION_ERROR":
      return { ...state, pending: false, last_error: action.payload };

    case GET_STAFF_CACHE_STATUS:
      return { ...state, cache_status: action.payload, pending: false };

    case INVALIDATE_STAFF_CACHE:
      return { ...state, cache_status: action.payload, pending: false };

    case GET_STAFF_ACCESS_LOGS:
      return { ...state, access_logs: action.payload, pending: false };

    case UPDATE_STAFF_REPORT_PAGE_NUMBER:
      return { ...state, pageNumber: action.payload };

    case "UPDATE_STAFF_REPORT_QUERY_PARAMS":
      return { ...state, queryParams: action.payload };

    default:
      return state;
  }
}
